export const category = [
    {
        name:'Network Camera',
        img:require('../../assets/Home/Frame.png'),
    },
    {
        name:'Network Video Recorder (NVR)',
        img:require('../../assets/Home/Frame.png'),
    },
    {
        name:'IP and Analog Cameras',
        img:require('../../assets/Home/Frame.png'),
    },
    {
        name:'Speed Dome(PTZ)',
        img:require('../../assets/Home/Frame.png'),
    }
]

export const BestSeller = [
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
    {
        name:'2 MP Build-in Mic Fixed Bullet Network Camera',
        img:require('../../assets/Home/Cctv.png'),
        OrgPrice:'5000',
        OffPrice:'2000',
        star:'4.5',
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not on ly five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I"
    },
]

export const DealBox = [
    {
        time:'04',
        name:'Days'
    },
    {
        time:'13',
        name:'Hour'
    },
    {
        time:'34',
        name:'Min'
    },
    {
        time:'56',
        name:'Sec'
    },
]

export const EssentialComboList = [
    {
        id:'1',
        title:'8MP Outdoor AI Surveillance Camera',
        sub:'These combo offers cater to a range of customer preferences and requirements,',
        status:false
    },
    {
        id:'2',
        title:'Professional Installation Service',
        sub:'Certified technicians will install and configure the surveillance system for optimal performance and reliability.',
        status:false
    },
    {
        id:'3',
        title:'DIY Installation Kit',
        sub:'Includes the 8MP outdoor AI surveillance camera, PoE switch, outdoor-rated Ethernet cables, and installation guide.',
        status:false
    },
    {
        id:'4',
        title:'Extended Warranty and Support Package',
        sub:'These combo offers cater to a range of customer preferences and requirements,',
        status:false
    },
    {
        id:'5',
        title:'8MP Outdoor AI Surveillance Camera',
        sub:'These combo offers cater to a range of customer preferences and requirements,',
        status:false
    },
]

export const installServiceList = [
    {
        id:'1',
        title:'Basic Installation Package',
        price:'$899.00',
        status:false
    },
    {
        id:'2',
        title:'Advanced Installation Package',
        price:'$1199.00',
        status:false
    },
    {
        id:'3',
        title:'Custom Installation Services',
        price:'$1699.00',
        status:false
    },
]


export const keyList = [
    {
        name:'High Resolution',
    },
    {    
        name:'Weatherproofing',
    },
    {    
        name:'Infrared Night Vision',
    },
    {    
        name:'Motion Detection',
    },
    {    
        name:'Object Recognition',
    },
    {    
        name:'Cloud Storage and Remote Access',
    },
    {    
        name:'Tamper Detection',
    },
    {    
        name:'Integration with Smart Home Systems',
    },
]
